import { FunctionComponent } from 'react'
import { Chip } from '../../shared'
import { AgentProfilePickerProps } from './AgentProfilePicker.model'
import styles from './AgentProfilePicker.module.scss'

export const AgentProfilePicker: FunctionComponent<AgentProfilePickerProps> = ({
  profiles,
  value,
  disabled,
  onChange,
}) =>
  // Un seul profil pour la spécialité du praticien : rien à choisir.
  profiles.length < 2 ? null : (
    <div className={styles.root}>
      <div className={styles.title}>Profils statistiques</div>
      <div className={styles.chips}>
        {profiles.map((profile) => (
          <Chip
            key={profile.key}
            label={profile.label}
            title={profile.description}
            size="small"
            selected={profile.key === value}
            disabled={disabled}
            onClick={() => onChange(profile.key)}
            testId={`chip-stats_assistant-agent_profile-${profile.key}`}
          />
        ))}
      </div>
    </div>
  )
